import { JawsSegmentationCreate, JawsSegmentationResponse } from '@/schema/jawsSegmentation';
import Api from './api';

const JawsSegmentationApi = {
  getById(id: string) {
    return Api.get<JawsSegmentationResponse>(`/jaws-segmentations/${id}`);
  },

  create(data: JawsSegmentationCreate, upperJawModel: Blob, lowerJawModel: Blob, lowerJawTeethModels: Blob[], upperJawTeethModels: Blob[]) {
    const formData = new FormData();
    formData.append('data', new Blob([JSON.stringify(data)], { type: 'application/json' }));

    formData.append('upperJawModel', upperJawModel);
    formData.append('lowerJawModel', lowerJawModel);

    lowerJawTeethModels.forEach((file) => formData.append('lowerJawTeethModels', file));

    upperJawTeethModels.forEach((file) => formData.append('upperJawTeethModels', file));

    return Api.postFile<number>('/jaws-segmentations', formData); // returns ID
  },
};

export default JawsSegmentationApi;
